import { MenuItem } from '@mui/material';

import INSTANCE_CLASSES from '../../../instanceClasses';
import AWS_RESOURCE_TYPES from './awsResourceTypes';

const RESOURCE_TYPE_MAPPING = {
  [AWS_RESOURCE_TYPES.V100]: {
    label: 'V100',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.T4]: {
    label: 'T4',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.L4]: {
    label: 'L4',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.A100]: {
    label: 'A100',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.A10G]: {
    label: 'A10G',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.L40S]: {
    label: 'L40S',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.H100]: {
    label: 'H100',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.H200]: {
    label: 'H200',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.B200]: {
    label: 'B200',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.B300]: {
    label: 'B300',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.RTX_PRO_4500]: {
    label: 'RTX PRO 4500',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.SMALL.value}>
        {INSTANCE_CLASSES.SMALL.label('(2)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.RTX_PRO_6000]: {
    label: 'RTX PRO 6000',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(1)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.SMALL.value}>
        {INSTANCE_CLASSES.SMALL.label('(2)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(4)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AWS_RESOURCE_TYPES.CPU]: {
    label: 'CPU Only',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
        {INSTANCE_CLASSES.MICRO.label('(8)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.SMALL.value}>
        {INSTANCE_CLASSES.SMALL.label('(16)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
        {INSTANCE_CLASSES.MEDIUM.label('(32)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(64)')}
      </MenuItem>,
      <MenuItem value={INSTANCE_CLASSES.XLARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(128)')}
      </MenuItem>,
    ],
  },
};
export default RESOURCE_TYPE_MAPPING;
